import React, { useContext } from "react";
import './App.css';
import 'remixicon/fonts/remixicon.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';  
import "./assets/css/style.css";
import "./assets/css/responsive.css";

import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import UserLayout from './layouts/UserLayout'; 
import Login from './pages/login';
import Register from './pages/Register';
import Success from './pages/Success'; 
import Main from './pages/Main'; 
import MyWallet from './pages/MyWallet';
import LegalNotices from './pages/LegalNotices';
import Chatroom from './pages/Chatroom';
import SendMessages from './pages/SendMessages';
import { AuthProvider } from './contexts/AuthContext';
import { GuestRoute, PrivateRoute } from './routes/RouteGuards'; 
import Subscription from "./pages/Subscription";
import ScrollToTop from "./ScrollToTop";
import TranslationProvider, { TranslationContext } from "./contexts/TranslationContext";
import Welcome from "./pages/Welcome";

const stripePromise = loadStripe("your-public-key-from-stripe"); 

function App() {
  return (
    <AuthProvider>
      <TranslationProvider>
        <Router>
          <ScrollToTop />
          <TranslatedRoutes />
        </Router>
      </TranslationProvider>
    </AuthProvider>
  );
}

function TranslatedRoutes() {
  const { routes } = useContext(TranslationContext);

  return (
    <Routes>
      <Route path="/" element={<UserLayout />}>
        <Route index element={<Navigate to={routes.login} replace />} />

        {/* Guest-only routes */}
        <Route path={routes.login} element={<GuestRoute><Login /></GuestRoute>} />
        <Route path={routes.register} element={<GuestRoute><Register /></GuestRoute>} />
        <Route path={routes.success} element={<GuestRoute><Success /></GuestRoute>} />

        {/* Authenticated-only routes */}
        <Route path={routes.home} element={<PrivateRoute><Main /></PrivateRoute>} />
        <Route path={routes.subscription} element={<PrivateRoute><Subscription /></PrivateRoute>} />
        <Route path={routes.legalNotices} element={<LegalNotices />} />
        <Route path={routes.myWallet} element={<PrivateRoute><Elements stripe={stripePromise}><MyWallet /></Elements></PrivateRoute>} />
        <Route path={routes.chatroom} element={<PrivateRoute><Chatroom /></PrivateRoute>} />
        <Route path={routes.sendMessages} element={<PrivateRoute><SendMessages /></PrivateRoute>} />
      </Route>
    </Routes>
  );
}

export default App;
